import { call, put, select, takeLatest } from 'redux-saga/effects'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import { initializeSaga } from '@/store/PageConfiguration/PageConfigurationSagas'
import { updateCarbonOffsetFormErrors } from './CarbonOffsetsSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'

export const carbonOffsetsActions = {
  UPDATE_CARBON_OFFSET: 'UPDATE_CARBON_OFFSET',
  CREATE_CARBON_OFFSET: 'CREATE_CARBON_OFFSET',
  DELETE_CARBON_OFFSET: 'DELETE_CARBON_OFFSET',
}

export function* updateCarbonOffset({ carbonOffsetData, id, initUrl, updateSuccessNotification, enqueue }) {
  try {
    const { country } = yield select(selectAuthData)
    const { routes } = yield select(selectPageConfigurationData)
    const endpoint = `${routes.update}?id=${id}`
    yield call(callApi, {
      endpoint,
      method: 'PUT',
      payload: carbonOffsetData,
      enqueue,
      showErrorSnackbar: false,
    })
    yield call(updateSuccessNotification, 'Carbon offset bien mise à jour')
    yield call(initializeSaga, { initUrl: initUrl + '?lang=' + country })
  } catch (error) {
    const errors = error?.validationErrors || error?.responseData?.errors
    if (errors) {
      yield put(updateCarbonOffsetFormErrors(errors))
    } else {
      console.error(error)
    }
  }
}

export function* createCarbonOffset({ carbonOffsetData, initUrl, updateSuccessNotification, enqueue }) {
  try {
    const { country } = yield select(selectAuthData)
    const { routes } = yield select(selectPageConfigurationData)
    const endpoint = routes.store
    const result = yield call(callApi, {
      endpoint,
      method: 'POST',
      payload: carbonOffsetData,
      enqueue,
      showErrorSnackbar: false,
    })
    yield call(updateSuccessNotification, 'Carbon offset crée')
    yield call(initializeSaga, { initUrl: initUrl + '?lang=' + country })
  } catch (error) {
    const errors = error?.validationErrors || error?.responseData?.errors
    if (errors) {
      yield put(updateCarbonOffsetFormErrors(errors))
    } else {
      console.error(error)
    }
  }
}

export function* deleteCarbonOffset({ id, onSuccess, onError, enqueue }) {
  try {
    const { extraRoutes } = yield select(selectAuthData)
    const rawUrl = extraRoutes?.devTools?.additionalSalesProductsDelete
    if (!rawUrl) {
      yield call(onError, 'carbonOffsetConfiguration:delete_endpoint_missing')
      return
    }
    const endpoint = rawUrl.replace('*id*', id)
    yield call(callApi, { endpoint, method: 'DELETE', enqueue, showErrorSnackbar: false })
    yield call(onSuccess)
  } catch (error) {
    if (error?.status === 404) {
      yield call(onError, 'carbonOffsetConfiguration:delete_not_found')
      return
    }
    const message = error?.responseData?.message || 'carbonOffsetConfiguration:delete_failed'
    yield call(onError, message)
  }
}

export default function* carbonOffsetsSagas() {
  yield takeLatest(carbonOffsetsActions.UPDATE_CARBON_OFFSET, updateCarbonOffset)
  yield takeLatest(carbonOffsetsActions.CREATE_CARBON_OFFSET, createCarbonOffset)
  yield takeLatest(carbonOffsetsActions.DELETE_CARBON_OFFSET, deleteCarbonOffset)
}
